import moment from 'moment';

/**
 * Duração formatada entre dois timestamps de status (ex: tempo de espera, tempo de trânsito).
 * Retorna "00:00:00" quando algum dos timestamps falta ou a diferença não é positiva.
 */
export function diffBetweenStatusTimestamps(de, para) {
    if (!de || !para) return '00:00:00';

    const dataAnterior = moment(de);
    const dataAtual = moment(para);

    const diffMs = dataAtual.diff(dataAnterior);
    if (diffMs <= 0) return '00:00:00';

    const duration = moment.duration(diffMs);
    const totalHoras = Math.floor(duration.asHours());
    const minutos = String(duration.minutes()).padStart(2, '0');
    const segundos = String(duration.seconds()).padStart(2, '0');

    if (totalHoras >= 24) {
        const dias = Math.floor(totalHoras / 24);
        const horasRestantes = String(totalHoras % 24).padStart(2, '0');
        return `${dias}d ${horasRestantes}:${minutos}:${segundos}`;
    }

    const horas = String(totalHoras).padStart(2, '0');
    return `${horas}:${minutos}:${segundos}`;
}
